/**
 * Global key listener for UI layers (modals, menus, previews) that must see keys before or regardless of
 * focus. Kept here so the DOM event source can be swapped by native shells.
 */
export function onGlobalKeyDown(handler: (e: KeyboardEvent) => void, opts: { capture?: boolean } = {}): () => void {
  if (typeof window === 'undefined') return () => {};
  const capture = opts.capture ?? false;
  window.addEventListener('keydown', handler, capture);
  return () => window.removeEventListener('keydown', handler, capture);
}
